import { Component, OnInit } from '@angular/core';
import { CoreService } from '../../../../../service/core.service';

@Component({
  selector: 'app-receipt-dash',
  templateUrl: './receipt-dash.component.html',
  styleUrls: ['./receipt-dash.component.css']
})
export class ReceiptDashComponent implements OnInit {
  up: any;

  constructor(private coreService: CoreService) { }

  ngOnInit() {
    this.up = this.coreService.getUserPrivilage();

  }

}
